import { installedItems } from "@p0security/shared/install/installed";
import { McpIconUrl } from "@p0security/shared/integrations/constants";
import { McpComponents } from "@p0security/shared/integrations/resources/mcp/components";

import type { FrontendInstaller } from "../../../install/types.ts";
import { Install, InstallProps } from "../Install/Install";

const identifier = () => "identifier";
const itemKind = (key: string) => key;

const mcpInstaller: FrontendInstaller<typeof McpComponents> = {
  gateway: { items: {} },
  server: {
    items: {
      gateway: {
        optionProvider: async ({ config }) =>
          Object.entries(installedItems("gateway", config)).map(
            ([id, item]) => ({ id, label: item?.label })
          ),
      },
    },
  },
} as const;

export const Mcp = (
  props: Pick<InstallProps<typeof McpComponents>, "cardOverride" | "onInstall">
) => (
  <Install<typeof McpComponents>
    components={McpComponents}
    installer={mcpInstaller}
    integration="mcp"
    itemKind={itemKind}
    identifier={identifier}
    logo={McpIconUrl}
    title="MCP server"
    {...props}
  />
);
